import * as React from 'react';

import { Alert } from '@emburse/ui-core';

interface IErrorAlertProps {
  errorMessage: string;
}

export const parseAndGetErrorMessage = function (errorMessage: string) {
  if (!errorMessage) return;
  let errorMessageParsed = errorMessage;
  try {
    const parsed = JSON.parse(errorMessage);
    errorMessageParsed = parsed.error || errorMessage;
  } catch (e) {}
  return errorMessageParsed;
};

export const ErrorAlert: React.FC<IErrorAlertProps> = ({ errorMessage }) => {
  const errorMessageParsed = parseAndGetErrorMessage(errorMessage);

  return (
    <Alert severity={'error'} className={'error-alert'}>
      {errorMessageParsed}
    </Alert>
  );
};
